"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToCannonObject = void 0;
var quat_1 = require("./quat");
var vector3_1 = require("./vector3");
// Transforms an object that contains Vector3 and Quat to their CANNON-es counterpart
function transformToCannonObject(state) {
    var e_1, _a;
    var out = {};
    try {
        for (var _b = __values(Object.entries(state)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
            if (typeof v.x === "number" &&
                typeof v.y === "number" &&
                typeof v.z === "number" &&
                typeof v.w === "number") {
                out[k] = (0, quat_1.toCannonQuaternion)(v);
            }
            else if (typeof v.x === "number" &&
                typeof v.y === "number" &&
                typeof v.z === "number") {
                out[k] = (0, vector3_1.toCannonVec3)(v);
            }
            else {
                out[k] = v;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
exports.transformToCannonObject = transformToCannonObject;
